import type React from 'react'

import type { DailyUsage } from '@/services/apiUsage'
import { ChartBars, ChartLegend, ChartXAxis, ChartYAxis } from './components'
import css from './styles.module.scss'
import { useDailyUsageChart } from './useDailyUsageChart'

interface DailyUsageChartProps {
  daily: DailyUsage[]
}

export const DailyUsageChart: React.FC<DailyUsageChartProps> = ({ daily }) => {
  const { bars, ticks, xLabels } = useDailyUsageChart(daily)

  return (
    <div className={css.container}>
      <div className={css.header}>
        <h2 className={css.title}>Daily usage</h2>
        <ChartLegend />
      </div>

      <div className={css.chart}>
        <ChartYAxis ticks={ticks} />

        <div className={css.plot}>
          {ticks.map((tick) => (
            <div
              key={tick.value}
              className={css.gridline}
              style={{ bottom: `${tick.bottom}%` }}
            />
          ))}

          <ChartBars bars={bars} />
          <ChartXAxis labels={xLabels} barCount={bars.length} />
        </div>
      </div>
    </div>
  )
}
